import React from 'react';
import clsx from 'clsx';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

const TransactionCard = ({ transaction }) => {
    const isIncome = transaction.type === 'income';

    return (
        <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-100 hover:shadow-sm transition-all duration-200">
            <div className="flex items-center gap-3">
                <div className={clsx(
                    "w-10 h-10 rounded-full flex items-center justify-center",
                    isIncome ? "bg-emerald-100 text-emerald-600" : "bg-rose-100 text-rose-600"
                )}>
                    {isIncome ? <ArrowUpRight size={18} /> : <ArrowDownRight size={18} />}
                </div>
                <div>
                    <h4 className="font-semibold text-gray-900 text-sm">{transaction.category}</h4>
                    <p className="text-xs text-gray-500">{transaction.date}</p>
                    {transaction.notes && (
                        <p className="text-[10px] text-gray-400 mt-0.5 line-clamp-1">{transaction.notes}</p>
                    )}
                </div>
            </div>
            <div className="text-right">
                <p className={clsx(
                    "text-base font-bold",
                    isIncome ? "text-emerald-600" : "text-rose-600"
                )}>
                    {isIncome ? '+' : '-'}₹{transaction.amount.toLocaleString('en-IN')}
                </p>
                <p className="text-[10px] text-gray-500">{transaction.paymentMode}</p>
            </div>
        </div>
    );
};

export default TransactionCard;
